export default __webpack_public_path__ + "static/cruiselines-carnival-activities-4-5a227ada28a2f944abaec02835ede0d7.jpg";